module.exports = __webpack_public_path__ + "static/media/2020.78979d28.csv";